// Utility function for extracting multiple parameters from a URL using a template generator and param names.
// Example: matchUrlParamsByTemplate(getStatementDownloadUrl, ['loanId', 'rowId'], '/api/loans/123/statements/456')
// returns { loanId: '123', rowId: '456' }
export function matchUrlParamsByTemplate(
  urlTemplateFn: (...placeholders: string[]) => string,
  paramNames: string[],
  url: string
): Record<string, string> | null {
  const placeholders = paramNames.map(name => `{${name}}`);
  const params = matchUrlParam(urlTemplateFn(...placeholders), url);
  if (!params) return null;
  return paramNames.reduce((acc, name) => {
    acc[name] = params[name];
    return acc;
  }, {} as Record<string, string>);
}
// Utility function for extracting parameters from a URL pattern.
// Example: matchUrlParam('/api/loans/{loanId}/statements/{rowId}', '/api/loans/123/statements/456')
// returns { loanId: '123', rowId: '456' }
export function matchUrlParam(pattern: string, url: string): Record<string, string> | null {
  const paramNames = [...pattern.matchAll(/\{([^}]+)\}/g)].map(m => m[1]);
  if (paramNames.length === 0) return null;
  let regexPattern = pattern;
  paramNames.forEach(name => {
    regexPattern = regexPattern.replace(`{${name}}`, '([^/]+)');
  });
  const patternRegex = new RegExp(`^${regexPattern}$`);
  const match = url.match(patternRegex);
  if (!match) return null;
  const result: Record<string, string> = {};
  paramNames.forEach((name, i) => {
    result[name] = match[i + 1];
  });
  return result;
}
